import moment from 'moment';
import * as types from '../actions/action-types';
import getStatus from '../helpers/status-substatus';
import * as tree from 'treetabular';

const INITIAL_STATE = {
    reportingLoading: false,
    reportingRssOssCodeList: [],
    reportingDistrictCodeList: [],
    reportingRegionCodeList: [
        {
            name: 'Western',
            code: 'west'
        },
        {
            name: 'Eastern',
            code: 'east'
        }
    ],
    reportingRecruitingStationCodeList: [],
    reportingCategoryList: [],
    reportingFiltersActive: false,
    sortingColumns: {},
    reportingAPIData: [],
    filterBtnAction: false
};

export const getReportingCategoryList = state => state.reportingCategoryList;
export const getFilterBtnAction = state => state.filterBtnAction;
export const getReportingFilters = state => state.reportingFilters;
export const getReportingRegionCodeList = state =>
    state.reportingRegionCodeList;
export const getReportingDistrictCodeList = state =>
    state.reportingDistrictCodeList;
export const getReportingRecruitingStationCodeList = state =>
    state.reportingRecruitingStationCodeList;
export const getReportingRssOssCodeList = state =>
    state.reportingRssOssCodeList;
export const getReportingData = state => state.reportingAPIData;
export const getReportingLoading = state => state.reportingLoading;

const mapReportingData = data => {
    data = data.map(item => {
        let rowdata = {};
        rowdata.id = item.id;
        if (item.Parent && item.Parent !== null) {
            rowdata.parent = item.Parent.id;
            rowdata.hasParent = true;
        }
        if (item.name && item.name !== null) rowdata.name = item.name;
        if (item.links && item.links !== null)
            rowdata.links = item.links[0].self;
        if (item.isFromEac && item.isFromEac !== null) {
            rowdata.isFromEac = 'Yes';
        } else if (!item.isFromEac && item.isFromEac !== null) {
            rowdata.isFromEac = 'No';
        }
        if (item.sourceCode && item.sourceCode !== null)
            rowdata.sourceCode = item.sourceCode;
        if (item.cost && item.cost !== null) {
            rowdata.cost = item.cost;
        } else {
            rowdata.cost = '';
        }
        if (item.formsSubmitted && item.formsSubmitted !== null)
            rowdata.formsSubmitted = item.formsSubmitted;
        if (item.Region && item.Region !== null)
            rowdata.RegionName = item.Region.name;
        if (item.District && item.District !== null)
            rowdata.DistrictName = item.District.name;
        if (item.RecruitingStation && item.RecruitingStation !== null)
            rowdata.RecruitingStationName = item.RecruitingStation.name;
        if (item.RecruitingSubStation && item.RecruitingSubStation !== null)
            rowdata.RecruitingSubStationName = item.RecruitingSubStation.name;
        if (item.OSS && item.OSS !== null)
            rowdata.RecruitingSubStationName = item.OSS.name;
        if (item.startDate && item.startDate !== null)
            rowdata.startDate = moment(item.startDate)
                .format('YYYY/MM/DD')
                .toString();
        if (item.estAttendance !== null)
            rowdata.estimatedTargetAttendance = item.estAttendance;
        if (item.Category && item.Category !== null) {
            rowdata.customCategory = '';
            for (let i = 0; i < item.Category.length; i++) {
                if (i === 0) {
                    rowdata.customCategory += item.Category[i].name;
                } else {
                    rowdata.customCategory += ', ' + item.Category[i].name;
                }
            }
        }

        if (item.PromoCodeStats !== null && item.cost !== null) {
            //PER backend they cannot modify the undefined thus undefined
            if (item.PromoCodeStats.PPC === undefined) {
                rowdata.EventReportcostPerPPC = 'Pending';
                // rowdata.EventReportcostPerPPC = Math.random() * 100;
            } else if (item.PromoCodeStats.PPC === 0 && item.cost === 0) {
                rowdata.EventReportcostPerPPC = 0;
                // rowdata.EventReportcostPerPPC = Math.random() * 100;
            } else if (item.PromoCodeStats.PPC === 0 && item.cost > 0) {
                rowdata.EventReportcostPerPPC = 'N/A';
                // rowdata.EventReportcostPerPPC = Math.random() * 100;
            } else {
                rowdata.EventReportcostPerPPC =
                    item.cost / item.PromoCodeStats.PPC;
            }
        } else {
            rowdata.EventReportcostPerPPC = 'Pending';
        }

        if (item.TotalQualifiedMarket !== null) {
            //PER backend they cannot modify the undefined thus undefined
            //will equate to pending
            if (item.TotalQualifiedMarket === undefined) {
                rowdata.EventReportcostPerEnlisted = '';
            } else {
                rowdata.EventReportcostPerEnlisted = item.TotalQualifiedMarket;
            }
        } else if (item.TotalQualifiedMarket === undefined) {
            rowdata.EventReportcostPerEnlisted = '';
        }

        if (item.Children.length > 0 && item.Children) {
            rowdata.children = item.Children;
            rowdata.showingChildren = false;
        }

        if (item.EventReport && item.EventReport !== null) {
            if (item.EventReport.leadCard !== null)
                rowdata.EventReportleadCards = item.EventReport.leadCards;
            if (item.Children && item.Children !== null) {
                let leadCardCount = rowdata.EventReportleadCards;
                for (let i = 0; i < item.Children.length; i++) {
                    leadCardCount += item.Children[i].EventReport.leadCards;
                }
                rowdata.EventReportleadCards = leadCardCount;
            }

            if (item.EventReport.emvAttend !== null) {
                let emvAttendValue;
                item.EventReport.emvAttend
                    ? (emvAttendValue = 'Yes')
                    : (emvAttendValue = 'No');
                rowdata.EventReportemvAttend = emvAttendValue;
            }
            if (item.EventReport.influencerContacts !== null)
                rowdata.EventReportinfluencerContacts =
                    item.EventReport.leadCards;
            if (item.EventReport.influencerContacts !== null)
                rowdata.EventReportinfluencerLeadCards =
                    item.EventReport.leadCards;
            if (item.EventReport.followUps !== null)
                rowdata.EventReportinterviewsScheduled =
                    item.EventReport.followUps;
            if (item.EventReport.attendance !== null)
                rowdata.EventReportattendance = item.EventReport.attendance;
            if (item.EventReport.influencerContacts !== null)
                rowdata.EventReportinfluencersAttended =
                    item.EventReport.influencerContacts;
            if (item.EventReport.influencerInteraction !== null)
                rowdata.EventReportinfluencersEngaged =
                    item.EventReport.influencerInteraction;
            if (item.EventReport.engagements !== null)
                rowdata.EventReportdirectEngaged = item.EventReport.engagements;
            if (item.EventReport.socialMediaPosts !== null)
                rowdata.EventReportsocialMediaPosts =
                    item.EventReport.socialMediaPosts;
            if (item.EventReport.socialMediaImpressions !== null)
                rowdata.EventReportsocialMediaImpressions =
                    item.EventReport.socialMediaImpressions;
            if (item.EventReport.mediaPosts !== null)
                rowdata.EventReporttraditionalMediaPosts =
                    item.EventReport.mediaPosts;
            if (item.EventReport.mediaImpressions !== null)
                rowdata.EventReporttraditionalMediaImpressions =
                    item.EventReport.mediaImpressions;
            if (item.estOnsiteActivations !== null)
                rowdata.EventReportonsiteActivations =
                    item.estOnsiteActivations;
        }

        if (item.PromoCodeStats !== null) {
            // be backwards compat with gender but use sex instead
            if (!!item.PromoCodeStats.GenderMale) {
               rowdata.genderMale = item.PromoCodeStats.GenderMale;
            } else if (!!item.PromoCodeStats.SexMale) {
               rowdata.genderMale = item.PromoCodeStats.SexMale;
            }
            if (!!item.PromoCodeStats.GenderFemale) {
               rowdata.genderFemale = item.PromoCodeStats.GenderFemale;
            } else if (!!item.PromoCodeStats.SexFemale) {
               rowdata.genderFemale = item.PromoCodeStats.SexFemale;
            }

            rowdata.ethnicityAsian = item.PromoCodeStats.EthnicityAsian;
            rowdata.ethnicityCaucasian = item.PromoCodeStats.EthnicityCaucasian;
            rowdata.ethnicityHispanic = item.PromoCodeStats.EthnicityHispanic;
            rowdata.ethnicityOther = item.PromoCodeStats.EthnicityOther;
            rowdata.ethnicityNA = item.PromoCodeStats.EthnicityUnknown;
            rowdata.ethnicityAfricanAmerican =
                item.PromoCodeStats.EthnicityAfricanAmerican;
            rowdata.genderFemale = item.PromoCodeStats.GenderFemale;
            rowdata.TotalQtyReceived = item.PromoCodeStats.TotalQtyReceived;
            rowdata.QualifiedLead = item.PromoCodeStats.QualifiedLead;
            rowdata.TotalNotLegible = item.PromoCodeStats.TotalNotLegible;
            rowdata.Incomplete = item.PromoCodeStats.Incomplete;
            rowdata.TotalCheckedYes = item.PromoCodeStats.TotalCheckedYes;
            rowdata.TotalCheckedNo = item.PromoCodeStats.TotalCheckedNo;
            rowdata.InvalidInformation = item.PromoCodeStats.InvalidInformation;
            rowdata.Purged = item.PromoCodeStats.Purged;
            rowdata.PPC = item.PromoCodeStats.PPC;
            rowdata.Contract = item.PromoCodeStats.Contract;
            rowdata.TotalQualifiedMarket =
                item.PromoCodeStats.TotalQualifiedMarket;
            rowdata.TotalResponse = item.PromoCodeStats.TotalResponse;
            rowdata.FirstResponse = item.PromoCodeStats.FirstResponse;
            rowdata.OfficerQualifiedLead =
                item.PromoCodeStats.OfficerQualifiedLead;
            rowdata.OfficerApplication = item.PromoCodeStats.OfficerApplication;
            rowdata.handHeldLeads = item.PromoCodeStats.HandheldLeads;
        }

        if (
            item.status !== null &&
            item.subStatus !== null &&
            item.EventReport !== null &&
            item.startDate !== null
        ) {
            let groupStatus = getStatus(
                item.status,
                item.subStatus,
                item.EventReport,
                item.startDate
            );
            rowdata.subStatus = groupStatus.status;
        }

        return rowdata;
    });

    const orderedData = tree.fixOrder({
        parentField: data.parent,
        id: data.id
    })(data);
    return orderedData;
};

export default (state = INITIAL_STATE, action) => {
    if (action.type === types.FETCH_REPORTING_ITEM) {
        return { ...state, reportingItems: action.payload };
    } else if (action.type === types.FETCH_REPORTING_CATEGORY) {
        return {
            ...state,
            reportingCategoryList: action.reportingCategoryList
        };
    } else if (action.type === types.TOGGLE_REPORTING_FILTERS) {
        return {
            ...state,
            reportingFiltersActive: !state.reportingFiltersActive
        };
    } else if (action.type === types.FETCH_REPORTING_DATA_SUCCESS) {
        return {
            ...state,
            reportingAPIData: mapReportingData(action.payload.data)
        };
    } else if (action.type === types.UPDATE_REPORTING_DISTRICT_SUCCESS) {
        return { ...state, reportingDistrictCodeList: action.payload };
    } else if (action.type === types.UPDATE_REPORTING_RS_SUCCESS) {
        return { ...state, reportingRecruitingStationCodeList: action.payload };
    } else if (action.type === types.UPDATE_REPORTING_RSS_OSS_SUCCESS) {
        return { ...state, reportingRssOssCodeList: action.payload };
    } else if (action.type === types.FILTER_BTN_ACTION) {
        return { ...state, filterBtnAction: !state.filterBtnAction };
    } else if (action.type === types.REPORTING_LOADING) {
        return {
            ...state,
            reportingLoading: !state.reportingLoading
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/reporting.js